import type { ComponentProps, ElementType } from "react";

import { cn } from "../../utils";

type SkeletonProps<T extends ElementType> = {
  as?: T;
} & ComponentProps<T>;

export const Skeleton = <T extends ElementType = "div">({ as, className, ...props }: SkeletonProps<T>) => {
  const Component = as ?? "div";

  return <Component className={cn("h-6 animate-pulse rounded-lg bg-neutral-90", className)} {...props} />;
};

export default Skeleton;
